import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import {
  EmailOriginEnum,
  EmployeeExtended,
  EmployeeGeneralData
} from '@pxtra-client-lib-legacy/gen';
import { DataGrid, DataGridElement } from '../../../../lib/components/compound/dataGrid';
import TranslationHelper from '../shared/translationHelper';
import Util from '../../../../misc/util';
import { EmployeeDataGridElement } from '../shared/dataGridElement';
import { Loading } from '../../../../lib/components';

interface Props {
  data?: EmployeeGeneralData;
  user?: EmployeeExtended['user'];
  userEmailOrigin?: EmailOriginEnum;
}

export const PersonalDataView: FC<Props> = ({ data, user, userEmailOrigin }) => {
  const { t } = useTranslation();
  const helper = new TranslationHelper(t);

  return data ? (
    <DataGrid>
      <EmployeeDataGridElement data={data} field="first_name" />
      <EmployeeDataGridElement data={data} field="last_name" />
      <EmployeeDataGridElement data={data} field="birth_last_name" />
      <EmployeeDataGridElement
        data={data}
        field="birth_date"
        renderValue={(date) => (date ? Util.formatDate(date as string) : '')}
      />
      <EmployeeDataGridElement
        data={data}
        field="gender"
        renderValue={(gender) =>
          typeof gender === 'string' ? (helper.gender.render(gender) ?? '') : ''
        }
      />
      <EmployeeDataGridElement
        data={data}
        field="marriage_status"
        title={t('employee:MARRIAGE_STATUS_QUESTION')}
        renderValue={(status) =>
          typeof status === 'string' ? (helper.marriageStatus.render(status) ?? '') : ''
        }
      />
      <EmployeeDataGridElement data={data} field="nationality" />
      <DataGridElement title={t('account:LOGIN_EMAIL_FIELD')} value={user?.email} />
      {userEmailOrigin === 'private' && (
        <Grid item xs={6} className="-mt-4 ml-auto">
          <Typography variant="caption" color="text.secondary">
            {t('employee:PRIVATE_EMAIL_HIDDEN_HINT')}
          </Typography>
        </Grid>
      )}
    </DataGrid>
  ) : (
    <Loading />
  );
};
